import axios from 'axios';
import config from '../Config';
import authHeader from './auth-header';

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;

const getBundleOutWardList = (
  page,
  pagesize,
  search,
  ordering,
  workOrderId,
  start_date,
  end_date,
) => {
  try {
    return axios.get(
      `${API_URL}/api/${API_VERSION}/bundle-outward/get-bundle-outward/`,
      {
        headers: authHeader(),
        params: {
          deleted: 0,
          page: page,
          pagesize: pagesize,
          search: search, // You might want to include search here, if applicable
          ordering: ordering,
          workOrderId: workOrderId,
          ...(start_date && {start_date: start_date}),
          ...(end_date && {end_date: end_date}),
        },
      },
    );
  } catch (error) {
    console.error('Error fetching bundle outward list:', error);
    throw error; // Ensure this is thrown for proper handling elsewhere
  }
};

const getBundleOutWardListById = id => {
  return axios.get(
    API_URL +
      '/api/' +
      API_VERSION +
      `/bundle-outward/get-bundle-outward/?bundle_outward_id=${id}`,
    {
      headers: authHeader(),
    },
  );
};

const getBundlePackingSlipData = id => {
  return axios.get(
    API_URL +
      '/api/' +
      API_VERSION +
      `/bundle-outward/packing-slip-summary/?bundle_outward_id=${id}`,

    {
      headers: authHeader(),
    },
  );
};

const getBundlePackingSlipbundle = id => {
  return axios.get(
    API_URL +
      '/api/' +
      API_VERSION +
      `/bundle-outward/packing-slip-bundles/?bundle_outward_id=${id}`,
    {
      headers: authHeader(),
    },
  );
};

const getBundleOutWardByItem = (
  page,
  pagesize,
  search,
  id,
  ordering,
  workOrderId,
  bundleOutwardId,
) => {
  return axios.get(
    API_URL +
      '/api/' +
      API_VERSION +
      `/bundle-outward/workorder-detail-by-workorder-id/${workOrderId}/?outward_id=${bundleOutwardId}`,
    {
      headers: authHeader(),
      params: {
        deleted: 0,
        page: page,
        pagesize: pagesize,
        search: search,
        ordering: ordering,
      },
    },
  );
};

const getBundleByWorkorderId = (
  page,
  pagesize,
  search,
  id,
  ordering,
  workOrderId,
  addData,
  bundleOutwardId
) => {
  return axios.patch(
    API_URL +
      '/api/' +
      API_VERSION +
      `/bundle-outward/${id}/bundle-inward-by-workorder-details/outward_id=${bundleOutwardId}`,
    {exclude_bundles: addData},
    {
      headers: authHeader(),
    },
  );
};

const getBundleByWorkorderRestoreId = (
  page,
  pagesize,
  search,
  id,
  ordering,
  workOrderId,
  restoreData,
) => {
  return axios.patch(
    API_URL + '/api/' + API_VERSION + `/bundle-outward/add-item-by-bundle-id/`,
    {bundle_id: restoreData},

    {
      headers: authHeader(),
    },
  );
};
const getBundleOutWardById = id => {
  return axios.get(`${API_URL}/api/${API_VERSION}/bundle-outward/${id}`, {
    headers: authHeader(),
  });
};
const getBundleOutWardByIdFinalize = outward_id => {
  return axios.get(
    `${API_URL}/api/${API_VERSION}/bundle-outward/${outward_id}`,
    {
      headers: authHeader(),
    },
  );
};
const getArchiveBundleOutWardList = (page, pagesize, search, ordering) => {
  return axios.get(
    API_URL + '/api/' + API_VERSION + '/bundle-outward/?deleted=1',
    {
      headers: authHeader(),
      params: {
        page: page,
        pagesize: pagesize,
        search: search,
        ordering: ordering,
      },
    },
  );
};

const getBudlelistExist = (
  page,
  pagesize,
  search,
 
  ordering,
  bundleId,
  added,
  bundleOutwardId,
) => {
  return axios.get(
    API_URL +
      '/api/' +
      API_VERSION +
      `/bundle-outward/${bundleId}/bundle-inward-by-workorder-details/?outward_id=${bundleOutwardId}`,
    {
      headers: authHeader(),
      params: {
        page: page,
        pagesize: pagesize,
        search: search,
        added: added,
      },
    },
  );
};
const addBundleItem = async sizeData => {
  try {
    const response = await axios.post(
      `${API_URL}/api/${API_VERSION}/bundle-outward/add-item-by-bundle-id/`,
      sizeData,
      {
        headers: authHeader(),
      },
    );
    return response.data; // Assuming the response contains the created die size data
  } catch (error) {
    console.error('Error creating die size:', error);
    throw error; // Ensure proper error handling
  }
};
const restoreBundleItem = async sizeData => {
  try {
    const response = await axios.post(
      `${API_URL}/api/${API_VERSION}/bundle-outward/restore-item-by-bundle-id/`,
      sizeData,
      {
        headers: authHeader(),
      },
    );
    return response.data; // Assuming the response contains the created die size data
  } catch (error) {
    console.error('Error creating die size:', error);
    throw error; // Ensure proper error handling
  }
};
const deleteBundleOutwardList = id => {
  return axios.delete(
    `${API_URL}/api/${API_VERSION}/bundle-outward/${id}/`, // Include `id` in the URL
    {
      headers: {
        ...authHeader(),
        'Content-Type': 'multipart/form-data', // Ensure proper header for FormData
      },
    },
  );
};
const createBundleOutWard = async sizeData => {
  try {
    const response = await axios.post(
      `${API_URL}/api/${API_VERSION}/bundle-outward/`,
      sizeData,
      {
        headers: authHeader(),
      },
    );
    return response.data; // Assuming the response contains the created die size data
  } catch (error) {
    console.error('Error creating die size:', error);
    throw error; // Ensure proper error handling
  }
};
const finalizeBundleOutward = async sizeData => {
  try {
    const response = await axios.patch(
      `${API_URL}/api/${API_VERSION}/bundle-outward/finalize-bundle/`,
      sizeData,
      {
        headers: authHeader(),
      },
    );
    return response.data; // Assuming the response contains the created die size data
  } catch (error) {
    console.error('Error creating die size:', error);
    throw error; // Ensure proper error handling
  }
};
const editBundleOutWard = (id, SizeData) => {
  return axios.patch(
    `${API_URL}/api/${API_VERSION}/bundle-outward/${id}/`,
    SizeData,
    {headers: authHeader()},
  );
};
const deleteBundleOutWard = id => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/bundle-outward/${id}/archive/`, // Include the die group's ID in the URL
    {},
    {headers: authHeader()}, // Authentication header
  );
};
const unArchiveBundleOutWard = id => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/bundle-outward/${id}/unarchive/`, // Include the die group's ID in the URL
    {}, // Pass an empty object if no data needs to be sent
    {headers: authHeader()}, // Authentication header
  );
};

const BundleOutWardService = {
  getBundleOutWardList,
  getBundlePackingSlipData,
  getArchiveBundleOutWardList,
  createBundleOutWard,
  getBundleOutWardListById,
  editBundleOutWard,
  getBundlePackingSlipbundle,
  deleteBundleOutwardList,
  deleteBundleOutWard,
  unArchiveBundleOutWard,
  getBundleOutWardByItem,
  getBundleOutWardById,
  getBundleOutWardByIdFinalize,
  getBundleByWorkorderId,
  getBundleByWorkorderRestoreId,
  getBudlelistExist,
  restoreBundleItem,
  addBundleItem,
  finalizeBundleOutward,
};

export default BundleOutWardService;
